import './style.css'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import range from 'lodash/range'
import { compose, withState } from 'recompose'
import { List } from 'immutable'

import { selectors as UsersSelectors } from 'data/users'
import { sliceListAroundIndex } from 'helpers/list'

import SearchBar from './SearchBar'
import UsersPickerRow from './Row'
import UsersPickerRowPlaceholder from './RowPlaceholder'
import { FocusNavigator } from 'components/Utils'

class UsersPicker extends Component {
  static propTypes = {
    autoFocus: PropTypes.bool,
    selectedUserIds: PropTypes.instanceOf(List).isRequired,
    onUserIdSelected: PropTypes.func.isRequired,
    onUserIdDeselected: PropTypes.func.isRequired,
    isSearchActive: PropTypes.bool.isRequired,
    setIsSearchActive: PropTypes.func.isRequired,
    showSelectedInSearchBar: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    autoFocus: true,
    showSelectedInSearchBar: true,
    onUserIdSelected: () => {},
    onUserIdDeselected: () => {},
  }

  onSearch = searchTerm => {
    this.props.setIsSearchActive(searchTerm.length > 0)
    this.props.setSearchTerm(searchTerm)
  }

  onUserIdSelected = id => {
    this.props.onUserIdSelected(id)
    this.onSearch('')
  }

  onUserIdDeselected = id => {
    this.props.onUserIdDeselected(id)
  }

  render() {
    const {
      selectedUserIds,
      allUserIds,
      isSearchActive,
      autoFocus,
      currentIndex,
      setCurrentIndex,
      searchTerm,
      matchingUserIds,
      showSelectedInSearchBar,
    } = this.props
    const baseUserIds = isSearchActive ? matchingUserIds : allUserIds
    const listUserIds = baseUserIds
      .filter(id => !selectedUserIds.includes(id)) // is not already selected
      .filter(id => allUserIds.includes(id)) // is not archived

    // Always show 5 results, and navigate through them
    const {
      slicedList,
      updatedIndex: updatedCurrentIndex,
    } = sliceListAroundIndex({
      list: listUserIds,
      index: currentIndex,
      maxSize: 5,
    })

    const placeHolderRange =
      slicedList.size < 5 ? range(slicedList.size, 5) : []

    return (
      <FocusNavigator
        onEnter={() => document.activeElement.click()}
        onTab={() => document.activeElement.focus()}
        nextOnEnter={true}
      >
        <SearchBar
          onSearch={this.onSearch}
          autoFocus={autoFocus}
          userIds={showSelectedInSearchBar ? selectedUserIds : List()}
          removeUserId={this.onUserIdDeselected}
          searchTerm={searchTerm}
        />
        <div className="border-top-none border-small border-shade-30 radius-bottom-normal">
          {slicedList.map((id, index) => (
            <UsersPickerRow
              key={id}
              id={id}
              onSelect={() => {
                this.onUserIdSelected(id)
              }}
              onFocus={() => {
                setCurrentIndex(currentIndex + index - updatedCurrentIndex)
              }}
              onBlur={() => setCurrentIndex(0)}
            />
          ))}
          {placeHolderRange.map(i => (
            <UsersPickerRowPlaceholder key={`placeholder-${i}`} />
          ))}
        </div>
      </FocusNavigator>
    )
  }
}

const mapStateToProps = (state, { allUserIds, searchTerm, currentUserId }) => ({
  allUserIds:
    allUserIds ||
    UsersSelectors.getAllUsers(state, { filterOutArchived: true })
      .map(u => u.id)
      .filter(userId => userId !== currentUserId)
      .toList(),
  matchingUserIds: UsersSelectors.searchUsers(state, searchTerm)
    .map(u => u.id)
    .filter(userId => userId !== currentUserId)
    .toList(),
})

export default compose(
  withState('isSearchActive', 'setIsSearchActive', false),
  withState('currentIndex', 'setCurrentIndex', 0),
  withState('searchTerm', 'setSearchTerm', ''),
  connect(mapStateToProps)
)(UsersPicker)
